import React, { useState } from 'react';
import { DryingLine } from '../components/DryingLine';
import { SONGS } from '../data/songs';
const BACKGROUND_IMAGE = 'https://cdn.magicpatterns.com/uploads/vNLpU9FCjqDMU5LWnBiDZL/IMG_5712.jpg';
export function Music() {
  // Reverse the songs array so the newest additions appear first on the line
  const reversedSongs = [...SONGS].reverse();
  const [selectedSong, setSelectedSong] = useState(reversedSongs[0]);
  return <>
      {/* Background Image */}
      <div className="pointer-events-none fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${BACKGROUND_IMAGE})`
    }} data-id="element-220" />

      {/* Dark overlay so the song photos remain prominent */}
      <div className="pointer-events-none fixed inset-0 z-0 bg-black/50" data-id="element-221" />

      {/* Centered vertically and horizontally */}
      <main className="relative z-10 flex min-h-screen flex-col items-center justify-center pt-16" data-id="element-222">
        {/* Streaming Service Buttons */}
        <div className="mb-8 flex w-full flex-wrap items-center justify-center gap-16 px-4 md:gap-32" data-id="element-223">
          <a href="https://open.spotify.com/artist/2IzFevrqE4isle6dtFrMnR?si=YMpb4-yhSmquqhJMFLjCmw" target="_blank" rel="noopener noreferrer" className="font-mono text-xs tracking-[0.2em] text-white/80 transition-colors hover:text-darkroom-red" data-id="element-224">
            SPOTIFY
          </a>
          <a href="https://music.apple.com/us/artist/lennon-cripe/1459603262" target="_blank" rel="noopener noreferrer" className="font-mono text-xs tracking-[0.2em] text-white/80 transition-colors hover:text-darkroom-red" data-id="element-225">
            APPLE MUSIC
          </a>
          <a href="https://soundcloud.com/lennoncripe?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing" target="_blank" rel="noopener noreferrer" className="font-mono text-xs tracking-[0.2em] text-white/80 transition-colors hover:text-darkroom-red" data-id="element-226">
            SOUNDCLOUD
          </a>
        </div>

        <div className="w-full" data-id="element-227">
          <DryingLine songs={reversedSongs} selectedSong={selectedSong} onSelect={setSelectedSong} data-id="element-228" />
        </div>

        {/* Secondary Streaming Service Links — below the line */}
        <div className="mt-8 flex w-full flex-wrap items-center justify-center gap-20 px-4 md:gap-56" data-id="element-229">
          <a href="https://music.youtube.com/@lennoncripe?si=_fs6D_66sQvBJrs4" target="_blank" rel="noopener noreferrer" className="font-mono text-xs tracking-[0.2em] text-white/80 transition-colors hover:text-darkroom-red" data-id="element-230">
            YOUTUBE MUSIC
          </a>
          <a href="https://tidal.com/artist/20992783/u" target="_blank" rel="noopener noreferrer" className="font-mono text-xs tracking-[0.2em] text-white/80 transition-colors hover:text-darkroom-red" data-id="element-231">
            TIDAL
          </a>
          <a href="https://music.amazon.co.uk/artists/B08G67X56M/lennon-cripe?marketplaceId=A1F83G8C2ARO7P&musicTerritory=GB&ref=dm_sh_o888Kk7YsdHRzU4egm0pcGFR7" target="_blank" rel="noopener noreferrer" className="font-mono text-xs tracking-[0.2em] text-white/80 transition-colors hover:text-darkroom-red" data-id="element-232">
            AMAZON MUSIC
          </a>
        </div>
      </main>
    </>;
}